export default {
    data: _ => ({
        coordKey: 'coord',
        items: [{
            id: 1,
            coord: {
                lat: 42.6636479,
                lng: 23.2574857
            },
            name: `<img class="maps-cdots" src="/static/img/text.svg" alt="cDots">
            <a href="https://www.google.bg/maps/dir//@42.6651228,23.2393936,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x40aa86f4bb22e09d:0x772bc8b0410a9eaa!2m2!1d23.274413!2d42.665065" target="_blank" class="contacts-left-btn">Google Maps</a>
            <a href="tel:+359889799988" class="contacts-left-btn1">0889 799 988</a>
            <a target="_blank" class="contacts-left-btn contacts-inquiry-btn" id="contactsInquiryBtn">Запитване</a>`
        }],
        map: null,
        Popup: null,
        popups: [],
        refName: 'gmap',
        uniqueId: 'id'
    }),

    mounted() {
        this.renderPopups();
    },

    methods: {
        /**
         * Defines a new javascript class to create popups on
         * a google map.
         *
         * Taken from https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
         */
        definePopupClass() {
            this.Popup = function(position, content, id) {
                this.position = position;

                content.classList.add('popup-bubble-content');

                var pixelOffset = document.createElement('div');
                pixelOffset.classList.add('popup-bubble-anchor');
                pixelOffset.appendChild(content);

                this.anchor = document.createElement('div');
                this.anchor.classList.add('popup-tip-anchor');
                this.anchor.id = id;
                this.anchor.appendChild(pixelOffset);

                this.stopEventPropagation();
            };

            this.Popup.prototype = Object.create(google.maps.OverlayView.prototype);

            this.Popup.prototype.onAdd = function() {
                this.getPanes().floatPane.appendChild(this.anchor);
            };

            this.Popup.prototype.onRemove = function() {
                if (this.anchor.parentElement) {
                    this.anchor.parentElement.removeChild(this.anchor);
                }
            };

            this.Popup.prototype.draw = function() {
                var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                var display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                    'block' :
                    'none';

                if (display === 'block') {
                    this.anchor.style.left = divPosition.x + 'px';
                    this.anchor.style.top = divPosition.y + 'px';
                }
                if (this.anchor.style.display !== display) {
                    this.anchor.style.display = display;
                }
            };

            this.Popup.prototype.stopEventPropagation = function() {
                var anchor = this.anchor;
                anchor.style.cursor = 'auto';

                [
                    'click',
                    'dblclick',
                    'contextmenu',
                    'wheel',
                    'mousedown',
                    'touchstart',
                    'pointerdown'
                ]
                .forEach(function(event) {
                    anchor.addEventListener(event, function(e) {
                        e.stopPropagation();
                    });
                });
            };
        },
        
        /**
         * Generate popups from an array of objects.
         */
        generatePopups() {
            this.items.forEach(i => {
                var el = document.createElement('div'),
                    id = 'popup-' + i[this.uniqueId],
                    coord = new google.maps.LatLng(i[this.coordKey].lat, i[this.coordKey].lng);
                el.innerHTML = this.htmlGenerator(i);
                var popup = new this.Popup(coord, el, id);
                popup.setMap(this.map);
                this.popups.push(popup);
            });
        },
        
        /**
         * Generates the html to display within the popup.
         *
         * @param object item
         *
         * @return string
         */
        htmlGenerator(item) {
            return item.name; 
        },
        
        /**
         * Adds popups to map once map has rendered.
         */
        renderPopups() {
            this.$refs[this.refName].$mapPromise.then((map) => {
                this.map = map;
                this.definePopupClass();
                this.generatePopups();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/googleMapPopupMixin.js